import Select from 'react-select'
import CreateableSelect from 'react-select/creatable'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import clsx from 'clsx'

interface Props {
	viewType: 'table' | 'box'
	changeViewType: (type: 'table' | 'box') => void
}

const ListFilter: React.FC<Props> = ({ changeViewType, viewType }) => {
	return (
		<div className="mt-2 mt-xl-0 row gy-5 align-items-center">
			<div className="d-block d-xl-none col-12">
				<div className="separator border-kumopack-grey-200" />
			</div>

			{/* Calendar */}
			<div className="col-12 col-xl-10 d-flex align-items-center flex-row">
				<Select
					className={clsx('d-inline-block', {
						'w-25': !isMobileDevice(),
						'w-auto': isMobileDevice(),
					})}
					styles={{
						control: provided => ({
							...provided,
							height: 40,
							minHeight: 0,
							borderTopLeftRadius: '8px',
							borderBottomLeftRadius: '8px',
							borderTopRightRadius: '0px',
							borderBottomRightRadius: '0px',
							borderColor: '#D0D5DD',
						}),
					}}
					components={{
						IndicatorSeparator: () => null,
					}}
					placeholder="รหัสคำสั่งซื้อ"
				/>
				<input
					placeholder="12345678"
					className="form-control d-inline-block border-kumopack-grey-300 h-40px"
					style={{
						borderLeft: 0,
						borderTopLeftRadius: '0px',
						borderBottomLeftRadius: '0px',
						width: isMobileDevice() ? '66%' : '75%',
					}}
				/>
			</div>
			<div className="col-12 col-xl-2">
				<button className="btn btn-sm white-button text-kumopackg-grey-700 fw-bold fs-8 w-100 h-40px">
					<img className="me-1" src="/media/icons/kumopack/calendar-2.svg" alt="Calendar 2 Icon" />
					Select Custom Date
				</button>
			</div>

			{/* Search Filter */}
			<div className="col-12 col-xl-8">
				<div className="position-relative">
					<img
						className="position-absolute"
						src="/media/icons/kumopack/file-search-02.svg"
						alt="File Search Icon"
						style={{ zIndex: 1, top: '22%', left: '10px' }}
					/>
					<CreateableSelect
						className="z-0"
						isMulti
						isSearchable
						styles={{
							control: provided => ({
								...provided,
								paddingLeft: '25px',
								minHeight: 40,
								borderRadius: '8px',
								borderColor: '#D0D5DD',
							}),
							multiValue: provided => ({
								...provided,
								backgroundColor: '#ffffff',
								border: '1px solid #D0D5DD',
								borderRadius: '4px',
							}),
						}}
						components={{
							IndicatorSeparator: () => null,
							DropdownIndicator: () => null,
							MultiValueLabel: ({ children }) => (
								<div className="bg-transparent px-1">{children}</div>
							),
						}}
						placeholder="ค้นหา"
					/>
				</div>
			</div>
			<div className="col-12 col-xl-2">
				<button className="btn btn-sm white-button text-kumopackg-grey-700 fw-bold fs-8 w-100 h-40px">
					Clear Search Filters
				</button>
			</div>

			{/* View Type Button Group */}
			<div className="col-12 col-xl-2">
				<div
					className="d-flex flex-row justify-content-center justify-content-xl-end align-items-center w-100 kumopack-button-group"
					style={{ columnGap: '0px' }}>
					<span className="me-2 text-kumopack-grey-500 d-none d-xl-block">การจัดเรียง</span>
					<button
						className={`btn btn-sm white-button left ${viewType === 'table' ? 'active' : ''}`}
						style={{ width: '30%' }}
						onClick={() => changeViewType('table')}>
						<img
							src="/media/icons/kumopack/list.png"
							alt="Filter Lines Icon"
							width={15}
							height={15}
						/>{' '}
					</button>
					<button
						className={`btn btn-sm white-button right ${viewType === 'box' ? 'active' : ''}`}
						style={{ width: '30%' }}
						onClick={() => changeViewType('box')}>
						<img
							src="/media/icons/kumopack/Box.png"
							alt="Filter Lines Icon"
							width={15}
							height={15}
						/>{' '}
					</button>
				</div>
			</div>
		</div>
	)
}

export default ListFilter
